import { render } from "./DataTitle.vue?vue&type=template&id=58871d76"
import script from "./DataTitle.vue?vue&type=script&lang=ts"
export * from "./DataTitle.vue?vue&type=script&lang=ts"
script.render = render

export default script